export const backdropOverlay = [
  'bg-alpha-600',
  'fixed',
  'inset-0',
  'z-1147483646',
  'motion-safe:data-[state=open]:animate-fade-in',
  'motion-safe:data-[state=closed]:animate-fade-out'
]
